import React from 'react'
import Icon from '../Icon'

/**
* Coupon Icon
*/
function CouponIcon(props) {
  return (
    <Icon
      icon="coupon"
      aria-hidden
      viewBox="0 0 31 31"
      role="presentation"
      {...props}
    >
      <g>
        <path d="M24.756,13.646l-11.11,11.11c-0.216,0.216 -0.486,0.324 -0.809,0.324c-0.324,0 -0.594,-0.108 -0.81,-0.324l-6.507,-6.507c-0.229,-0.228 -0.342,-0.498 -0.342,-0.81c0,-0.311 0.113,-0.581 0.342,-0.809l11.11,-11.11c0.216,-0.216 0.485,-0.324 0.81,-0.324c0.323,0 0.592,0.108 0.808,0.324l6.508,6.508c0.229,0.227 0.342,0.497 0.342,0.809c0,0.311 -0.113,0.581 -0.342,0.809m4.873,-3.596l-2.266,-2.247c-0.67,0.671 -1.486,1.007 -2.445,1.007c-0.959,0 -1.773,-0.336 -2.444,-1.007c-0.672,-0.671 -1.007,-1.486 -1.007,-2.445c0,-0.959 0.336,-1.774 1.007,-2.445l-2.248,-2.248c-0.444,-0.443 -0.987,-0.665 -1.627,-0.665c-0.642,0 -1.184,0.222 -1.627,0.665l-16.307,16.289c-0.443,0.443 -0.665,0.986 -0.665,1.627c0,0.641 0.222,1.183 0.665,1.627l2.247,2.265c0.672,-0.671 1.487,-1.007 2.446,-1.007c0.959,0 1.773,0.336 2.445,1.007c0.671,0.672 1.007,1.487 1.007,2.445c0,0.959 -0.336,1.774 -1.007,2.445l2.265,2.265c0.444,0.444 0.986,0.666 1.627,0.666c0.641,0 1.184,-0.222 1.627,-0.666l16.307,-16.324c0.443,-0.443 0.665,-0.986 0.665,-1.627c0,-0.641 -0.222,-1.183 -0.665,-1.627" />
        <path d="M17.44,7.156l5.682,5.681l-10.284,10.284l-5.681,-5.681l10.283,-10.284Z" />
      </g>
    </Icon>
  )
}

export default CouponIcon
